import Vue from 'vue'

const app = {
  state: {
    device: 'desktop', // 当前是什么设备
    bannerIndex: 0, // 首页bannerIndex
    solutionParams: {
      path: 'internet',
      index: 0
    }, // 解决方案 对象
    companyIndex: 0, // 关于我们
  },
  mutations: {
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_BANNER_INDEX: (state, num) => {
      state.bannerIndex = num
    },
    SET_SOLUTION_PARAMS: (state, params) => {
      state.solutionParams = params
    },
    SET_COMPANY_INDEX: (state, index) => {
      state.companyIndex = index
    }
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js